<template>
  <div class="text-center">
    <v-dialog
      v-model="_dialog"
      scrollable
      persistent
      width="500"
    >
      <!--
      @click:outside="_dialog = false"
      @keydown="_dialog = false"
    -->
      <v-card>
        <v-card-title class="font-weight-bold primary text-h3 white--text">
          Vinculação de Perfil
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Usuário"
                readonly
                :value="usuario"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <validation-provider
                v-slot="{ errors }"
                rules="required"
              >
                <v-select
                  v-model="perfil_"
                  :items="perfis"
                  label="Perfis"
                  item-value="perfil"
                  item-text="perfil"
                  prepend-icon="mdi-key"
                  :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn 
            text
            class="pa-12 text-h2"
            @click="_dialog = false"
          >
            Fechar
          </v-btn>
          <v-spacer />
          <v-btn 
            text
            class="pa-12 text-h2"
            @click="$emit('click:save', {'uid': uid, 'perfil': perfil_, 'usuario': usuario})"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    uid: {
      type: String,
      required: true
    },
    usuario: {
      type: String,
      required: true
    },
    perfil: {
      type: String,
      required: true
    },
    perfis: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    perfil_: undefined
  }),

  computed: {
    _dialog: {
      get() {
        return this.dialog;
      },
      set(newValue) {
        this.$emit('update:dialog', newValue);
      }
    }
  },

  watch: {
    perfil(newValue) {
      this.perfil_ = newValue;
    }
  }
};
</script>